
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import Message from 'primevue/message'
import workspaceWarningDialogDescriptor from './WorkspaceWarningDialogDescriptor.json'

export default defineComponent({
    name: 'workspace-warning-dialog',
    components: { Dialog, Message },
    emits: ['close'],
    props: { visible: { type: Boolean }, title: { type: String }, warningMessage: { type: String } },
    data() {
        return {
            workspaceWarningDialogDescriptor
        }
    }
})
